export default __webpack_public_path__ + "static/media/github.a1eced6e.svg";